// Lightweight GA4 event helper. Safely no-ops if gtag is unavailable.
export const trackEvent = (name, params = {}) => {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', name, params);
  }
};
